import PropTypes from 'prop-types';
import './Heading.scss';

const Heading = ({
  h4Text = '',
  h2Text = '',
  h4Size = 'small',
  h2Size = 'big',
  align = 'left',
  h4Color = 'primary',
  className = '',
}) => {
  const headingClasses = `heading ${className} align-${align}`;
  const h4Class = `h4-${h4Size} ${h4Size === 'small' ? 'text-big' : ''} color-${h4Color}`;

  const H2Tag = h2Size === 'small' ? 'h3' : 'h2';
  const h2Class = `h2-${h2Size}`;

  return (
    <div className={headingClasses}>
      {h4Text && <h4 className={`${h4Class} body-heading`}>{h4Text}</h4>}
      {h2Text && <H2Tag className={h2Class}>{h2Text}</H2Tag>}
    </div>
  );
};

Heading.propTypes = {
  h4Text: PropTypes.string,
  h2Text: PropTypes.string,
  h4Size: PropTypes.oneOf(['small', 'big']),
  h2Size: PropTypes.oneOf(['small', 'big']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  h4Color: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string,
};

export default Heading;
